import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public loading$ = new BehaviorSubject(false);

  constructor() { }

  start(){
    this.loading$.next(true);
  }

  finish(){
    this.loading$.next(false);
  }

  show(time: number = 5000){
    this.loading$.next(true);
    setTimeout(() => {
      this.loading$.next(false);
    }, time)
  }
}
